import { c as _c } from "react/compiler-runtime";
export function Logo(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M8.35 24.05 2 11.3 4.7 10 11 22.7l-2.65 1.35Zm7 14L10 27.35l2.65 -1.4L18 36.65l-2.65 1.4Zm4.05 -10L11.05 11.3l2.7 -1.3 8.35 16.7 -2.7 1.35Zm4.35 -10 -3.3 -6.7L23.1 10l3.3 6.65 -2.65 1.4ZM24.95 38l-3.35 -6.65L24.25 30l3.35 6.65L24.95 38Zm9.3 0L25.9 21.35l2.65 -1.4 8.35 16.7L34.25 38Zm3.1 -11.95L30 11.35 32.65 10 40 24.7l-2.65 1.35Zm6 12L39 29.35 41.65 28 46 36.7l-2.65 1.35Z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" role="img" fill="currentColor" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}